import { GeneralNumber } from '../../general-fields/definitions/general-number'
import { FormsFieldPreset } from '@wix/forms-common'

export class CrmNumber extends GeneralNumber {
  public get fieldType() {
    return FormsFieldPreset.CRM_NUMBER
  }

  protected get crmLabel() {
    return this.translate(`fieldTypes.${FormsFieldPreset.GENERAL_NUMBER}`)
  }

  protected get data(): any {
    return {
      textType: 'number',
    }
  }
}
